import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useEffect } from "react";
import { getFormDataById } from "../../redux/slices/getFormDataSlice";
import { ThemeProvider } from "styled-components";

import { theme } from "../../config/Config";

import Header from "../components/shared/Header";
import { CircularProgress } from "@mui/material";
import Investment from "../components/shared/Investment";
import EuropeLeaseProjectDetails from "../components/shared/EuropeLeaseProjectDetails";
import Attachments from "../components/shared/Attachments";
import Authorization from "../components/shared/Authorization";
import CapAuthActionButtons from "../components/actionButtons/ActionButtons";
import Loader from "../components/utils/Loader";

const EuropeLeaseAuthorization = () => {
    const formData = useAppSelector((state) => state.getFormData);
    const { id } = useParams();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (id) {
            dispatch(getFormDataById(id))
        }
    }, [id]);

    return (
        <>
            {!formData?.loading ? <div className="form-dv form-field-label">
                <ThemeProvider theme={theme}>
                    <Header />
                    <Investment />
                    <EuropeLeaseProjectDetails />
                    <Attachments />
                    <Authorization authType="EuropeLeaseAuth" />
                    <CapAuthActionButtons />
                    <Loader />
                </ThemeProvider>

            </div> : <div className="loading-backdrop loading-backdrop-full">
                <CircularProgress />
            </div>}
        </>
    );
};

export default EuropeLeaseAuthorization;
